module.exports = __webpack_public_path__ + "assets/img/4.40a9bcbd.png";